import { withProps } from 'recompose'
import { getVehicleTireSize } from 'helpers/vehicle'
import Trailer from './Trailer'

const withTrailerProps = withProps(({ tireFrontSize, tireRearSize }) => ({
  tireSize: getVehicleTireSize({ tireFrontSize, tireRearSize })
}))

export default withTrailerProps(Trailer)
